import { useState, useEffect } from 'react';
import { useAccount } from '../contexts/AccountContext';
import useDebounce from './useDebounce';

export const useSearchBehavior = (initialSearchTerm = '', debounceDelay = 1000) => {
  const { accountSettings } = useAccount();
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
  const [manualSearch, setManualSearch] = useState(initialSearchTerm);
  
  // Para busca instantânea (com debounce)
  const debouncedSearch = useDebounce(searchTerm, debounceDelay);
  
  // Determina qual valor de busca usar baseado na configuração
  const activeSearchTerm = accountSettings.instantSearch ? debouncedSearch : manualSearch;
  
  // Função para executar busca manual (quando instant search está desabilitado)
  const handleManualSearch = () => {
    setManualSearch(searchTerm);
  };
  
  // Função para limpar a busca
  const clearSearch = () => {
    setSearchTerm('');
    setManualSearch('');
  };
  
  return {
    searchTerm,
    setSearchTerm,
    activeSearchTerm,
    handleManualSearch,
    clearSearch,
    isInstantSearch: accountSettings.instantSearch,
  };
}; 